"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OmniConfigSchema = exports.OmniModelRoleSchema = exports.CreditFacilityConfigWithSlugSchema = exports.FinancialStatementLocalizationConfigSchema = exports.FinancialDisplayFormatSchema = exports.LocalizationConfigSchema = exports.LocalizationScopeSchema = exports.OwnerSettingsConfigSchema = exports.BorrowerConfigSchema = exports.OrganizationTypeIterable = exports.OrganizationTypeSchema = exports.USER_ROLE_TYPES = exports.UserRoleTypeIterable = exports.UserRoleTypeSchema = exports.UserTypeIterable = exports.UserTypeSchema = exports.BaseOrganizationSchema = exports.CreditFacilitySourceConfigSchema = exports.FundingRequestDocxGenerationConfigSchema = exports.DocxDocumentGenerationConfigSchema = exports.ReceivablesSaleAgreementGenerationConfigSchema = void 0;
const zod_1 = require("zod");
const Bank_1 = require("./Bank");
const Email_1 = require("./Email");
const FundingRequest_1 = require("./FundingRequest");
const Report_1 = require("./Report");
exports.ReceivablesSaleAgreementGenerationConfigSchema = zod_1.z.object({
    receivablesSaleAgreement: zod_1.z.boolean(),
});
exports.DocxDocumentGenerationConfigSchema = zod_1.z.object({
    fundingComponentTypes: FundingRequest_1.FundingRequestComponentTypeSchema.array().describe('Funding component types to be included in the document generation.'),
});
// FundingRequestDocxGenerationConfig is a record of ReportType to DocxDocumentGenerationConfig
exports.FundingRequestDocxGenerationConfigSchema = zod_1.z.partialRecord(Report_1.ReportTypeSchema, exports.DocxDocumentGenerationConfigSchema);
exports.CreditFacilitySourceConfigSchema = zod_1.z.object({
    isEnabledForStreaming: zod_1.z
        .boolean()
        .optional()
        .describe('Set this to true if borrower is enabled for streaming.'),
    digestEmailDeliveryCadence: zod_1.z
        .array(Email_1.DeliveryCadenceSchema)
        .describe('Decides the cadence of digest email delivery.'), // Could use DeliveryCadenceSchema if available
    isEnabledForBorrowingBaseReserve: zod_1.z
        .boolean()
        .describe('Set this to true if borrower is enabled for borrowing base reserve.'),
    isBorrowingBaseReservePositiveExcessCollectionsOverReserve: zod_1.z
        .boolean()
        .describe('Decides if the borrower is borrowing base reserve positive excess collections over reserve.'),
    receivablesSaleAgreementGenerationConfig: exports.ReceivablesSaleAgreementGenerationConfigSchema.describe('Configuration for receivables sale agreement generation.'),
    fundingRequestDocxGenerationConfig: exports.FundingRequestDocxGenerationConfigSchema.optional().describe('Configuration for funding request docx generation.'),
    cashBalancesFeedMethodPointer: zod_1.z
        .string()
        .nullable()
        .describe('Cash balance conversion pointer.'),
    f1FormulaEngine: zod_1.z
        .enum(['compareOnly', 'use'])
        .optional()
        .describe('Temporary optional flag for formula engine evaluation use'),
});
// Re-export from SharedOrganization to avoid circular dependencies
// The Zod schemas are defined in SharedOrganization.ts which has no circular deps
var SharedOrganization_1 = require("./Shared/SharedOrganization");
Object.defineProperty(exports, "BaseOrganizationSchema", { enumerable: true, get: function () { return SharedOrganization_1.BaseOrganizationSchema; } });
Object.defineProperty(exports, "UserTypeSchema", { enumerable: true, get: function () { return SharedOrganization_1.UserTypeSchema; } });
Object.defineProperty(exports, "UserTypeIterable", { enumerable: true, get: function () { return SharedOrganization_1.UserTypeIterable; } });
Object.defineProperty(exports, "UserRoleTypeSchema", { enumerable: true, get: function () { return SharedOrganization_1.UserRoleTypeSchema; } });
Object.defineProperty(exports, "UserRoleTypeIterable", { enumerable: true, get: function () { return SharedOrganization_1.UserRoleTypeIterable; } });
Object.defineProperty(exports, "USER_ROLE_TYPES", { enumerable: true, get: function () { return SharedOrganization_1.USER_ROLE_TYPES; } });
Object.defineProperty(exports, "OrganizationTypeSchema", { enumerable: true, get: function () { return SharedOrganization_1.OrganizationTypeSchema; } });
Object.defineProperty(exports, "OrganizationTypeIterable", { enumerable: true, get: function () { return SharedOrganization_1.OrganizationTypeIterable; } });
exports.BorrowerConfigSchema = zod_1.z.object({
    isEnabledForStreaming: zod_1.z
        .boolean()
        .optional()
        .describe('Set this to true if borrower is enabled for streaming.'),
    allowsMultipleMeshes: zod_1.z
        .boolean()
        .optional()
        .describe('Set this to true when a borrower intentionally has multiple uploadable meshes per latest graph.'),
    internalSlack: zod_1.z
        .object({
        channel: zod_1.z.string(),
        webhookUri: zod_1.z.string(),
    })
        .nullable()
        .describe('Internal slack notification config'),
    cashBalancePreference: Bank_1.CashBalanceTypeSchema,
    slug: zod_1.z.string(),
    digestEmailSections: zod_1.z.array(Email_1.DigestEmailSectionSchema),
});
/**
 * Settings scoped to an owner organization (e.g. a lender). Keyed on the owner
 * organization slug, so a single owner enables behavior across every facility
 * it owns and all of its implementations.
 */
exports.OwnerSettingsConfigSchema = zod_1.z.object({
    slug: zod_1.z.string(),
    allowReportingDateBeforeClosingDate: zod_1.z
        .boolean()
        .optional()
        .describe('When true, BBPL may run for reporting dates before the credit agreement closing date for all facilities owned by this organization.'),
});
/**
 * Localization configuration for custom label mappings per organization
 * Allows organizations to customize the display labels used in their UI
 */
exports.LocalizationScopeSchema = zod_1.z.enum(['borrowingBaseSummary']);
exports.LocalizationConfigSchema = zod_1.z.object({
    labelMappings: zod_1.z
        .record(exports.LocalizationScopeSchema, zod_1.z.record(zod_1.z.string().describe('Default label key'), zod_1.z.string().describe('Localized/customized label value')))
        .describe('Mapping of scopes to label key-value pairs for customization'),
});
/**
 * Financial display format options
 */
exports.FinancialDisplayFormatSchema = zod_1.z
    .enum(['K', 'M', 'B', 'full'])
    .describe('Format for displaying financial values: K (thousands), M (millions), B (billions), or full');
/**
 * Financial statement formatting configuration
 * Allows organizations to customize how financial values are displayed
 */
exports.FinancialStatementLocalizationConfigSchema = zod_1.z.object({
    financialFormatting: zod_1.z
        .object({
        displayFormat: exports.FinancialDisplayFormatSchema,
    })
        .describe('Configuration for financial statement value formatting'),
});
exports.CreditFacilityConfigWithSlugSchema = exports.CreditFacilitySourceConfigSchema.extend({
    creditFacilitySlug: zod_1.z.string(),
});
/**
 * Omni model role configuration
 * Maps an Omni model ID to an access role
 */
exports.OmniModelRoleSchema = zod_1.z.object({
    modelId: zod_1.z.string().describe('Omni model ID'),
    modelRole: zod_1.z
        .enum(['VIEWER', 'RESTRICTED_QUERIER', 'QUERIER'])
        .describe('Access role for the model'),
});
/**
 * Omni Analytics configuration per organization
 * Controls which Omni models the organization has access to
 */
exports.OmniConfigSchema = zod_1.z.object({
    modelRoles: zod_1.z
        .array(exports.OmniModelRoleSchema)
        .describe('List of Omni models and their access roles for this organization'),
    analyticsClientId: zod_1.z
        .string()
        .trim()
        .min(1)
        .optional()
        .describe('Client identifier injected as the analyticsClientId Omni user attribute for RLS (e.g. Salesforce account id 001G000001GWcRqIAL). Omit for internal/unscoped orgs. Must be non-empty when present.'),
    analyticsEntityKey: zod_1.z
        .string()
        .trim()
        .min(1)
        .optional()
        .describe('Stable Omni embed entity key that namespaces which analytics content this org sees. Must be identical across local/stage/prod so one dashboard is shared on the single Omni instance (unlike the environment-specific organizationId). Defaults to the org slug when omitted. Must be non-empty when present — an empty value would collapse multiple orgs into one content namespace.'),
    analyticsDefaultPath: zod_1.z
        .string()
        .trim()
        .min(1)
        .regex(/^\//, 'analyticsDefaultPath must start with "/"')
        .optional()
        .describe('Optional embed landing path. Set to a dashboard path (e.g. "/dashboards/c647311b") to deep-link the analytics view straight to that dashboard instead of the content browser. Must start with "/". Defaults to "/" (content browser root) when omitted.'),
    analyticsLinkAccess: zod_1.z
        .string()
        .trim()
        .min(1)
        .optional()
        .describe('Controls which Omni dashboard links are followable from within the embed. "__omni_link_access_open" allows all Omni dashboard links (needed for cross-dashboard nav from an overview); a comma-separated list of dashboard ids allowlists only those. Defaults to "__omni_link_access_open" so links between curated dashboards work; set to a tighter allowlist to restrict. (When unset in the signed URL, Omni hides/disallows all inter-dashboard links.)'),
});
//# sourceMappingURL=Organization.js.map